//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    deleteStudent: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/deletestudent", { id }, successCallback, failureCallback);
    },
    deleteStudents: (selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/deletestudents", { selectedIds }, successCallback, failureCallback);
    },
    shiftStudents: (origClassId, targClassId, selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/shiftstudents", { origClassId, targClassId, selectedIds }, successCallback, failureCallback);
    },
    searchHomework: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/searchhomework", { searchVO }, successCallback, failureCallback);
    },
    shiftStudentsNew: (origClassId, targClassId, selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/shiftstudentsnew", { origClassId, targClassId, selectedIds }, successCallback, failureCallback);
    },
    sendReminding: (classId, selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/sendreminding", { classId, selectedIds }, successCallback, failureCallback);
    },
    activateAccount: (classId, selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/details/activateAccount", { classId, selectedIds }, successCallback, failureCallback);
    },
};

export default DetailsService;
